import tbl from './entityTable.module.css';

/**
 * Color-coded chip for an entity's type (Event / Resource / CDT).
 *
 * Presentational and app-agnostic: it takes the normalized lowercase `type`
 * (as produced by `parsePk`) and renders a themed pill. Used by the release
 * plan tables (deprecate + hard-delete) so the type presentation stays in one
 * place.
 *
 * @param {object} props
 * @param {'event'|'resource'|'cdt'|string} props.type
 */
const TYPE_LABELS = { event: 'Event', resource: 'Resource', cdt: 'CDT' };

export default function EntityTypeChip({ type }) {
  const label = TYPE_LABELS[type] || type || '—';
  return <span className={`${tbl.typeChip} ${tbl[`type_${type}`] || ''}`}>{label}</span>;
}
